module.exports = __webpack_public_path__ + "pc/img/bg7.1d00b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprintClass/new/bg7.png
// module id = nz9x
// module chunks = 3